import Icon from "../atoms/Icon";
import Image from "next/image";
import { Button } from "../atoms/Button";
import { Heading } from "../atoms/Heading";
import { resolveLegacyLink } from "@/app/utils/linkUtils";
import { useEffect, useState } from "react";
import { buildProspectLink } from "@/app/utils/prospectLink";
import PreCommandePopup from "@/app/components/CommandePopup";

type MenuCardProps = {
  image: string;
  icon?: string;
  title: string;
  subtitle?: string;
  description: string;
  ctaLabel: string;
  ctaLink?: string;
  style?: string;
  price?: {
    main: string;
    sub?: string;
    extra?: string;
  };
};

export function MenuCard({
  image,
  icon,
  title,
  subtitle,
  description,
  ctaLabel,
  style,
  price,
}: MenuCardProps) {

  const [commanderHref, setCommanderHref] = useState<string>(
    resolveLegacyLink("/parcours-prospects", "clients")
  );

  useEffect(() => {
    const link =
      buildProspectLink() || resolveLegacyLink("/parcours-prospects", "clients");
    setCommanderHref(link);
  }, []);
  const [showPreCommandePopup, setShowPreCommandePopup] = useState(false);
  return (
    <div className="relative rounded-2xl overflow-hidden ">
      {/* Image */}
      <Image src={image} alt={title} width={828} height={1034} />

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-black via-dark/60 to-transparent" />

      {/* Badge prix */}
      {price && (
        <div className={`absolute top-6 right-6 bg-primaryGreen text-white rounded-full w-28 h-28 
        gap-2 flex flex-col items-center justify-center text-center shadow-lg p-2 ${style}`}>
          <span className="text-[14px] font-semibold leading-tight">
            {price.main}
          </span>
          {price.sub && (
            <span className="text-[10px] leading-tight opacity-80">
              {price.sub}
            </span>
          )}
          {price.extra && (
            <span className="text-[10px] leading-tight">{price.extra}</span>
          )}
        </div>
      )}

      {/* Contenu */}
      <div className="absolute bottom-5 p-6 text-white w-full">
        {icon && <Icon src={icon} alt="icon" className="w-16 h-16 mb-2" />}
        <Heading as="h4" className="text-xl font-bold">
          {title}
        </Heading>
        {subtitle && <p className="text-sm opacity-90">{subtitle}</p>}

        <div className="h-[3px] bg-primaryGreen w-16 my-3"></div>

        <p className="text-sm mb-4">{description}</p>
        <Button
          type="button"
          onClick={() => setShowPreCommandePopup(true)}
          className="bg-secondary z-50 hover:bg-primaryGreen text-white font-bold py-6 px-6 rounded-lg text-sm"
        >
          {ctaLabel.toUpperCase()}
        </Button>

        {showPreCommandePopup && (
          <PreCommandePopup
            onClose={() => setShowPreCommandePopup(false)}
            parcoursHref={commanderHref}
          />
        )}

      </div>
    </div>
  );
}
